import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { PublicClientApplication, BrowserUtils } from '@azure/msal-browser';
import { msalConfig } from './config/authConfig';
import { Dashboard } from './pages/Dashboard';
import { LoginPage } from './pages/LoginPage';

// MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

/**
 * App Component
 * Ana uygulama bileşeni - MSAL Provider ile sarılmış
 */
function App() {
  // Popup içinde çalışıyorsak, sadece MsalProvider'ı render et
  // MSAL callback'i handle etsin ama UI gösterme
  if (BrowserUtils.isInPopup()) {
    return (
      <MsalProvider instance={msalInstance}>
        <div />
      </MsalProvider>
    );
  }

  return (
    <MsalProvider instance={msalInstance}>
      {/* Giriş yapmış kullanıcılar için */}
      <AuthenticatedTemplate>
        <Dashboard />
      </AuthenticatedTemplate>

      {/* Giriş yapmamış kullanıcılar için */}
      <UnauthenticatedTemplate>
        <LoginPage />
      </UnauthenticatedTemplate>
    </MsalProvider>
  );
}

export default App;
